const colors = {
  white: '#fff',
  black: '#000',
  dark_grey_lighter: '#757575',
  dark_grey_lightest: '#595959',
  dark_grey_light: '#444',
  dark_grey_dark: '#333',
  dark_grey_darker: '#262626',
  dark_grey_darkest: '#1F1F1F',
  light_grey_lightest: '#FAFAFA',
  light_grey_lighter: '#FDFDFD',
  light_grey_light: '#F0F0F0',
  light_grey_dark: '#DBDBDB',
  light_grey_darker: '#CCCCCC',
  light_grey_darkest: '#949494',
  green_lightest: '#D5FCE9',
  green_lighter: '#A3F2CD',
  green_light: '#74D8A8',
  green_dark: '#0FCE72',
  green_darker: '#008A48',
  green_darkest: '#008545',
  red_lightest: '#F9D7D7',
  red_lighter: '#F4B5B5',
  red_light: '#F67979',
  red_dark: '#d42d2d',
  red_darker: '#ca2121',
  red_darkest: '#B71A1A',
}

export default colors;
